"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var traverse_1 = require("./traverse");
var visitMemberExpression = function (expr) {
    if (traverse_1.isMemberExpression(expr)) {
        if (traverse_1.isMemberExpression(expr.object) && traverse_1.isIdentifier(expr.property)) {
            return visitMemberExpression(expr.object).concat([expr.property.name]);
        }
        if (traverse_1.isIdentifier(expr.object) && traverse_1.isIdentifier(expr.property)) {
            return [expr.object.name, expr.property.name];
        }
    }
    if (traverse_1.isIdentifier(expr)) {
        return [expr.name];
    }
    return [];
};
var visit = function (expression) {
    var dependencies = [];
    var visitor = function (expr) {
        if (traverse_1.isMemberExpression(expr) && traverse_1.isIdentifier(expr.property)) {
            var identifier = {
                type: 'Identifier',
                name: visitMemberExpression(expr.object).concat([expr.property.name]).join('.'),
            };
            if (!dependencies.includes(identifier.name)) {
                dependencies.push(identifier.name);
            }
        }
        else {
            traverse_1.traverse(expr, visitor);
        }
        return expr;
    };
    visitor(expression);
    return dependencies;
};
exports.createDependenciesBuilder = function (config) { return function (map) {
    return Object.keys(map).reduce(function (acc, path) {
        var _a;
        return __assign({}, acc, (_a = {}, _a[path] = visit(map[path]), _a));
    }, {});
}; };
//# sourceMappingURL=dependencies.js.map